import { render, staticRenderFns } from "./invoices-base-summary.vue?vue&type=template&id=40cbeab2&scoped=true&"
import script from "./invoices-base-summary.vue?vue&type=script&lang=js&"
export * from "./invoices-base-summary.vue?vue&type=script&lang=js&"
import style0 from "./invoices-base-summary.vue?vue&type=style&index=0&id=40cbeab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbeab2",
  null
  
)

export default component.exports